module.exports = __webpack_public_path__ + "img/4.57af9e56.jpg";